import "@/App.css";
import "@/print.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";

import LandingPage from "@/pages/LandingPage";
import PaymentSuccess from "@/pages/PaymentSuccess";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import BrandAssets from "@/pages/BrandAssets";
import Suspended from "@/pages/Suspended";

import DashboardLayout from "@/pages/dashboard/DashboardLayout";
import Overview from "@/pages/dashboard/Overview";
import Children from "@/pages/dashboard/Children";
import ChildDetail from "@/pages/dashboard/ChildDetail";
import Compliance from "@/pages/dashboard/Compliance";
import Records from "@/pages/dashboard/Records";
import Billing from "@/pages/dashboard/Billing";
import LessonPlans from "@/pages/dashboard/LessonPlans";
import Attendance from "@/pages/dashboard/Attendance";
import StaffApp from "@/pages/dashboard/StaffApp";
import StaffDocuments from "@/pages/dashboard/StaffDocuments";
import StaffTrainings from "@/pages/dashboard/StaffTrainings";
import StaffFiles from "@/pages/dashboard/StaffFiles";
import StaffSubstitutes from "@/pages/dashboard/StaffSubstitutes";
import LicensingDocuments from "@/pages/dashboard/LicensingDocuments";
import PlaygroundInspections from "@/pages/dashboard/PlaygroundInspections";
import ParentApp from "@/pages/dashboard/ParentApp";
import Messages from "@/pages/dashboard/Messages";
import AdminLeads from "@/pages/dashboard/AdminLeads";
import VaultLock from "@/components/VaultLock";
import VaultReset from "@/pages/VaultReset";
import VaultSettings from "@/pages/dashboard/VaultSettings";
import Settings from "@/pages/dashboard/Settings";
import DrillLog from "@/pages/dashboard/DrillLog";
import FoodMenu from "@/pages/dashboard/FoodMenu";
import Pricing from "@/pages/Pricing";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import Refund from "@/pages/Refund";
import QuoteFillPage from "@/pages/QuoteFillPage";
import SuperAdmin from "@/pages/SuperAdmin";
import AcceptInvite from "@/pages/AcceptInvite";
import ErrorBoundary from "@/components/ErrorBoundary";
import "@/lib/global_error_handler";

function App() {
  return (
    <ErrorBoundary>
    <div className="App">
      <Toaster position="top-right" richColors closeButton />
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/refund" element={<Refund />} />
            <Route path="/checkout/success" element={<PaymentSuccess />} />
            <Route path="/login" element={<Login />} />
            <Route path="/brand" element={<BrandAssets />} />
            <Route path="/register" element={<Register />} />
            <Route path="/accept-invite/:token" element={<AcceptInvite />} />
            <Route path="/vault/reset/:token" element={<VaultReset />} />
            <Route path="/quote-fill/:token" element={<QuoteFillPage />} />
            <Route path="/suspended" element={<Suspended />} />

            <Route
              path="/superadmin"
              element={
                <ProtectedRoute roles={["superadmin"]}>
                  <SuperAdmin />
                </ProtectedRoute>
              }
            />

            <Route
              element={
                <ProtectedRoute>
                  <DashboardLayout />
                </ProtectedRoute>
              }
            >
              <Route path="/dashboard" element={<Overview />} />
              <Route path="/dashboard/children" element={<Children />} />
              <Route path="/dashboard/children/:id" element={<ChildDetail />} />
              <Route path="/dashboard/attendance" element={<Attendance />} />
              <Route path="/dashboard/lesson-plans" element={<LessonPlans />} />
              <Route path="/dashboard/compliance" element={<Compliance />} />
              {/* Vault-locked sensitive cluster (iter-81ac). One shared
                  passcode unlocks all of these: Licensing File, Staffs File,
                  Drill Log, Playground, Food Menu, Staff App, Substitutes.
                  Records is its own separate passcode. Billing has its own too. */}
              <Route element={<VaultLock />}>
                <Route path="/dashboard/records" element={<Records />} />
                <Route path="/dashboard/staff" element={<StaffApp />} />
                <Route path="/dashboard/staff/substitutes" element={<StaffSubstitutes />} />
                <Route path="/dashboard/staff-files" element={<StaffFiles />} />
                <Route path="/dashboard/staff/documents" element={<StaffFiles />} />
                <Route path="/dashboard/staff/trainings" element={<StaffFiles />} />
                <Route path="/dashboard/licensing" element={<LicensingDocuments />} />
                <Route path="/dashboard/licensing/food-menu" element={<FoodMenu />} />
                <Route path="/dashboard/playground" element={<PlaygroundInspections />} />
                <Route path="/dashboard/drill-log" element={<DrillLog />} />
              </Route>
              <Route path="/dashboard/billing" element={<Billing />} />
              <Route path="/dashboard/parent-app" element={<ParentApp />} />
              <Route path="/dashboard/messages" element={<Messages />} />
              <Route path="/dashboard/vault-settings" element={<VaultSettings />} />
              <Route path="/dashboard/settings" element={<Settings />} />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute roles={["admin"]}>
                    <AdminLeads />
                  </ProtectedRoute>
                }
              />
            </Route>
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
    </ErrorBoundary>
  );
}

export default App;
